import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["open"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import cn from 'classnames';
import React from 'react';
import { Button } from '@vtblife/uikit';
import useDOMRoot from '@vtblife/uikit/dist/hooks/use-dom-root';
import ReactDOM from 'react-dom';
import styles from './quiz-modal-layout.module.css';
export var QuizModalLayout = function QuizModalLayout(_ref) {
  var open = _ref.open,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!open) {
    return null;
  }
  return React.createElement(CreatePortal, _objectSpread({}, props));
};
function CreatePortal(props) {
  var root = useDOMRoot({
    anchor: 'modal-launchpad',
    style: styles.root
  });
  if (!root) {
    return null;
  }
  return ReactDOM.createPortal(React.createElement(Layout, _objectSpread({}, props)), root);
}
var Layout = function Layout(_ref2) {
  var background = _ref2.background,
    children = _ref2.children,
    onClose = _ref2.onClose,
    _ref2$layout = _ref2.layout,
    layout = _ref2$layout === void 0 ? '6c' : _ref2$layout,
    currentStep = _ref2.currentStep,
    disableClosing = _ref2.disableClosing;
  return React.createElement("div", {
    className: cn(styles.container, styles["background-".concat(background)], styles["layout-".concat(layout)])
  }, !disableClosing && React.createElement(React.Fragment, null, background === 'transparent' && React.createElement("div", {
    className: styles.overlay,
    onClick: function onClick() {
      return onClose({
        quizStep: currentStep
      });
    }
  }), !disableClosing && React.createElement("span", {
    className: styles.close
  }, React.createElement(Button, {
    icon: "times",
    size: "l",
    circle: true,
    variant: "transparent",
    onClick: function onClick() {
      return onClose({
        quizStep: currentStep
      });
    },
    iconColor: background === 'transparent' ? 'rgb(255, 255, 255)' : 'rgba(116, 109, 147, 0.5)'
  }))), React.createElement("div", {
    className: styles.contentBlock
  }, React.createElement("div", {
    className: styles.contentBlockInner
  }, children)));
};